import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../Icon';
import { uploadFile } from '../../../actions';
import FileUpload from '../../../utils/FileUpload';

var AppConfig = require('../../../config.json');

/**
 * A simple InputOrderFormCheckboxTeacher.
 */


class InputOrderFormCheckboxTeacher extends React.Component {
	constructor(props) {
	  super(props);
		this.handleToggleClick = this.handleToggleClick.bind(this);
		this.handleUpload = this.handleUpload.bind(this);
		this.checkForUploadStatus = this.checkForUploadStatus.bind(this);
	  this.state = {active:this.props.selected, init:false, isUploading: false};
	}
	componentDidMount() {
		this.setState({init:true});
	}

	componentWillUpdate(nextProps, nextState) {
		if(nextProps.upload.isSuccess && !this.props.upload.isSuccess && nextProps.upload.type===this.props.type) {
			
			this.props.addUpload(nextProps.upload.path, this.props.type, this.state.validDate);
		}
	}


	handleToggleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(this.props.type, nextState, this.props.alreadyUploaded);
	}
	handleUpload(file) {
		if(this.props.upload.isUploading) {
			return;
		}

		if(this.refs.fileupload.state.isUploading) {
			this.setState({isUploading:!this.state.isUploading});
		}
		
		var formdata = new FormData();
		formdata.append('files', file);
        this.props.dispatch(uploadFile(formdata, this.props.type, this.state.validDate));
        
		
	}


	checkForUploadStatus() {
		if(this.props.upload.isUploading && this.props.upload.type===this.props.type) {
			// console.log('is uploading')
			return true;
		}
		return false;
	}

    render () {
        return (
          <div className={`orderformcheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleToggleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className={`desc`}>
            		<h4>{AppConfig.teacher.upload.label}</h4>
            		{AppConfig.teacher.upload.desc!==''?
            			<div className="subline" style={{color:"black"}}>
		              		{AppConfig.teacher.upload.desc} (<a href={AppConfig.teacher.overlay.download} target="_blank">Download Vorlage</a>)
		              	</div>
		              	:null
            		}
            	</div>
            	{!this.props.alreadyUploaded?
            		
	            	<div className={`uploadarea`}>
	            		<FileUpload ref="fileupload" active={this.state.active} isUploading={this.checkForUploadStatus()} handleUpload={this.handleUpload} headline={`${AppConfig.teacher.upload.label}`} />
		            </div>
		            :
		            <div className="alreadyUploaded">Der Nachweis wurde erfolgreich hochgeladen.</div>
	        	}
            </div>

          </div>
        );
    }

}


InputOrderFormCheckboxTeacher.propTypes = {
	
	/** InputOrderFormCheckboxTeacher selected */
	selected: PropTypes.bool,
	/** InputOrderFormCheckboxTeacher Label */
	type: PropTypes.string.isRequired,
	alreadyUploaded: PropTypes.bool,
}


InputOrderFormCheckboxTeacher.defaultProps = {
  selected: false,
  alreadyUploaded: false,
  type: ""
}

const mapStateToProps = (state) => {
  return {
    upload: state.upload
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputOrderFormCheckboxTeacher)



// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormCheckboxTeacher.js